/* Plants in a Ute — theme behaviour.
   Deliberately small: presentation only. Capacity, overbooking and reminders
   belong to the booking app / Shopify inventory, not the theme.
   Re-runs safely on Theme Editor section loads. */
(() => {
  'use strict';

  const init = () => {
    /* ---------- mobile nav ---------- */
    const burger = document.getElementById('burger');
    const mnav = document.getElementById('mnav');
    if (burger && mnav && !burger.dataset.bound) {
      burger.dataset.bound = '1';
      burger.addEventListener('click', () => {
        const open = mnav.hasAttribute('open');
        mnav.toggleAttribute('open', !open);
        burger.setAttribute('aria-expanded', String(!open));
      });
      mnav.querySelectorAll('a').forEach((a) =>
        a.addEventListener('click', () => {
          mnav.removeAttribute('open');
          burger.setAttribute('aria-expanded', 'false');
        })
      );
    }

    /* ---------- booking tabs (roving tabindex) ---------- */
    const tabs = [...document.querySelectorAll('[data-tab]')];
    const panels = [...document.querySelectorAll('[data-panel]')];
    const selectTab = (tab) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach((p) => p.classList.toggle('is-on', p.dataset.panel === tab.dataset.tab));
    };
    tabs.forEach((tab, i) => {
      if (tab.dataset.bound) return;
      tab.dataset.bound = '1';
      tab.addEventListener('click', () => selectTab(tab));
      tab.addEventListener('keydown', (e) => {
        const step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        e.preventDefault();
        const next = tabs[(i + step + tabs.length) % tabs.length];
        next.focus();
        selectTab(next);
      });
    });

    /* workshop cards / CTAs land on the right booking tab */
    document.querySelectorAll('[data-jumptab]').forEach((el) => {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      el.addEventListener('click', () => {
        const t = tabs.find((x) => x.dataset.tab === el.dataset.jumptab);
        if (t) selectTab(t);
      });
    });

    /* enquire links prefill the contact form subject */
    document.querySelectorAll('[data-subject]').forEach((el) => {
      if (el.dataset.boundSubject) return;
      el.dataset.boundSubject = '1';
      el.addEventListener('click', () => {
        const s = document.getElementById('c-subject');
        if (s) s.value = el.dataset.subject;
      });
    });

    /* "Other" options reveal their free-text follow-up (required only while shown) */
    document.querySelectorAll('select[data-reveal]').forEach((sel) => {
      if (sel.dataset.bound) return;
      sel.dataset.bound = '1';
      const wrap = document.getElementById(sel.dataset.reveal);
      const input = wrap && wrap.querySelector('input,textarea');
      sel.addEventListener('change', () => {
        const on = sel.value === 'Other';
        if (wrap) wrap.classList.toggle('is-on', on);
        if (input) {
          input.required = on;
          if (!on) input.value = '';
        }
      });
    });

    /* journey read-more */
    const jbtn = document.getElementById('journey-btn');
    const jmore = document.getElementById('journey-more');
    if (jbtn && jmore && !jbtn.dataset.bound) {
      jbtn.dataset.bound = '1';
      jbtn.addEventListener('click', () => {
        const on = jmore.classList.toggle('is-on');
        jbtn.setAttribute('aria-expanded', String(on));
        jbtn.querySelector('span').textContent = on ? 'Close the story' : 'Read the whole story';
      });
    }

    /* ---------- session booking dialog ----------
       Thin wrapper over a real /cart/add form: the button that opened it
       supplies the variant and the seats still on sale, so quantity is capped
       by live inventory reported by the section. */
    const dlg = document.getElementById('bk');
    if (dlg && !dlg.dataset.bound) {
      dlg.dataset.bound = '1';
      const qty = document.getElementById('bk-qty');
      const variant = document.getElementById('bk-variant');
      const submit = document.getElementById('bk-go');
      const note = document.getElementById('bk-note');

      document.querySelectorAll('.js-book').forEach((btn) => {
        btn.addEventListener('click', () => {
          const d = btn.dataset;
          document.getElementById('bk-title').textContent = d.title || '';
          document.getElementById('bk-date').textContent = d.date || '';
          document.getElementById('bk-time').textContent = d.time || '';
          document.getElementById('bk-venue').textContent = d.venue || '';

          const max = Math.max(1, parseInt(d.places || '10', 10));
          qty.max = max;
          qty.value = 1;
          if (variant) variant.value = d.variant || '';

          const sellable = Boolean(d.variant);
          submit.disabled = !sellable;
          note.hidden = sellable;

          if (typeof dlg.showModal === 'function') dlg.showModal();
          else dlg.setAttribute('open', '');
        });
      });

      qty.addEventListener('input', () => {
        const max = Number(qty.max);
        if (Number(qty.value) > max) qty.value = max;
        if (Number(qty.value) < 1 || qty.value === '') qty.value = 1;
      });

      const x = dlg.querySelector('.bk__x');
      if (x) x.addEventListener('click', (e) => { e.preventDefault(); dlg.close(); });
    }

    /* ---------- product variant picker ---------- */
    const form = document.querySelector('[data-product-form]');
    if (form && !form.dataset.bound) {
      form.dataset.bound = '1';
      const data = document.getElementById('product-variants');
      if (data) {
        const variants = JSON.parse(data.textContent);
        const idInput = form.querySelector('[name="id"]');
        const addBtn = form.querySelector('[data-add]');
        const priceEl = document.querySelector('[data-price]');

        form.addEventListener('change', () => {
          const chosen = [...form.querySelectorAll('input[type="radio"]:checked')].map((i) => i.value);
          const match = variants.find((v) => v.options.every((o, i) => o === chosen[i]));
          if (!match) return;

          idInput.value = match.id;
          if (priceEl && match.price_formatted) priceEl.innerHTML = match.price_formatted;
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? addBtn.dataset.add : addBtn.dataset.soldout;

          const url = new URL(window.location);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url);
        });
      }
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
